// Club News Service - API calls for news/Beiträge management

import { apiClient } from './apiClient';
import { NewsPostItem, CreateNewsPostRequest } from '../types/clubNews.types';

export interface CommentItem {
  id: string;
  parentType: string;
  parentId: string;
  authorPersonId: string;
  authorName: string;
  content: string;
  createdAt: string;
  updatedAt: string | null;
}

class ClubNewsService {
  async getPosts(scopeType?: string, scopeDepartmentId?: string, page: number = 1, pageSize: number = 50): Promise<NewsPostItem[]> {
    const params: Record<string, string> = { page: String(page), pageSize: String(pageSize) };
    if (scopeType) params.scopeType = scopeType;
    if (scopeDepartmentId) params.scopeDepartmentId = scopeDepartmentId;
    const response = await apiClient.get('/club/news', { params });
    return response.data;
  }

  async getPost(id: string): Promise<NewsPostItem> {
    const response = await apiClient.get(`/club/news/${id}`);
    return response.data;
  }

  async createPost(data: CreateNewsPostRequest): Promise<NewsPostItem> {
    const response = await apiClient.post('/club/news', data);
    return response.data;
  }

  async updatePost(id: string, data: CreateNewsPostRequest): Promise<NewsPostItem> {
    const response = await apiClient.put(`/club/news/${id}`, data);
    return response.data;
  }

  async deletePost(id: string): Promise<void> {
    await apiClient.delete(`/club/news/${id}`);
  }

  async getComments(postId: string): Promise<CommentItem[]> {
    const response = await apiClient.get(`/club/news/${postId}/comments`);
    return response.data;
  }

  async deleteComment(postId: string, commentId: string): Promise<void> {
    await apiClient.delete(`/club/news/${postId}/comments/${commentId}`);
  }
}

export const clubNewsService = new ClubNewsService();
